import './style.css'
import { infoSite } from '../../../state/atom'
import { useRecoilState } from 'recoil'

export default function InputInfo(params: any) {
  const [info, setInfo] = useRecoilState(infoSite)

  return (
    <div className="inputInfo">
      <input
        type="text"
        placeholder="Nome "
        onChange={(e) => {
          setInfo({
            ...info,
            Nome: e.target.value,
          })
        }}
      />
      <input
        type="text"
        placeholder="Regione"
        onChange={(e) => {
          setInfo({
            ...info,
            Regione: {
              Nome: e.target.value,
              Url: '',
            },
          })
        }}
      />
    </div>
  )
}
